import CustomizedComparison from "../components/PeerGroup/CustomizedComparison";
import { connect } from "react-redux";
import { All, KeyValue, Query } from "../interfaces";
import { Dispatch } from "react";
import * as actions from "../common/actions";

function mapStateToProps({ appState }: All) {
  return {
    appState: appState.peerGroup,
  };
}
function mapDispatchToProps(dispatch: Dispatch<actions.AllActions>) {
  return {
    updateUi: (
      uiField: string,
      uiValue: KeyValue[] | string[] | string | KeyValue,
    ) => {
      dispatch(actions.updateUi(uiField, uiValue));
      dispatch(actions.searchPush());
    },
    resetState: (state: Query) => {
      dispatch(actions.resetState(state));
    },
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CustomizedComparison);
